import { createContext, useContext, useEffect, useState } from "react";
import { useAppState } from "./app-state";
import { authenticateApp } from "./auth-context";

interface IUserDeatilsContext {
  // save-user-details
  userDetails: any;
  setUserDetails: (value: any) => void;
  ayurvedaCorrelation: any;
  setAyurvedaCorrelation: (value: any) => void;
  callUserDetails: () => Promise<void>;
  refetchUserDetails: () => void; // Added refetch function
}

export const userDeatilsContext = createContext<IUserDeatilsContext>(
  {} as IUserDeatilsContext
);

const useUserDetailsProvider = () => {
  const { clinicUserId } = authenticateApp();
  const { currentClinic, onShowSnackbarWithAction, setAppLoading, setError } =
    useAppState();
  // userDetails
  const [userDetails, setUserDetails] = useState<any>(null);

  // ayurveda-correlation
  const [ayurvedaCorrelation, setAyurvedaCorrelation] = useState<any>(null);

  // Add refetch state
  const [refetch, setRefetch] = useState<boolean>(false);

  const callUserDetails = async () => {
    // Only proceed if we have both required parameters
    if (!clinicUserId || !currentClinic) {
      return;
    }

    try {
      setError(null);
      setAppLoading(true);

      // const response = await diseaseAPI.getUserDetails(
      //   clinicUserId,
      //   currentClinic,
      //   "user-details"
      // );

      // setUserDetails(response);
      setRefetch(false); // Reset refetch flag after successful fetch
    } catch (error) {
      setError(error);
      onShowSnackbarWithAction("Error fetching user details", "error");
    } finally {
      setAppLoading(false);
    }
  };

  // Function to trigger refetch
  const refetchUserDetails = () => {
    setRefetch(true);
  };

  // Effect that runs when clinicUserId or currentClinic change or refetch is triggered
  useEffect(() => {
    // Only call the API if we don't have userDetails yet AND we have the required parameters
    // OR if refetch flag is true
    if ((!userDetails && clinicUserId && currentClinic) || refetch) {
      callUserDetails();
    }
  }, [clinicUserId, currentClinic, refetch]);

  // questionResponse for static questions
  return {
    userDetails,
    setUserDetails,
    ayurvedaCorrelation,
    setAyurvedaCorrelation,
    callUserDetails,
    refetchUserDetails, // Export the refetch function
  };
};

interface Props {
  children: React.ReactNode;
}

export const UserDetailsProvider = ({ children }: Props) => {
  const app = useUserDetailsProvider();

  return (
    <userDeatilsContext.Provider value={app}>
      {children}
    </userDeatilsContext.Provider>
  );
};

export const useUserDetailsState = () => {
  return useContext(userDeatilsContext);
};
